/* HP8 tiny swiper — mobile only, no deps */
(() => {
  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));

  function init(root) {
    const track = root.querySelector('.mcit-swiper__track');
    if (!track) return;
    const slides = Array.from(track.children);
    if (!slides.length) return;

    const prevBtn = root.querySelector('.mcit-swiper__btn--prev');
    const nextBtn = root.querySelector('.mcit-swiper__btn--next');
    const dotsWrap = root.querySelector('.mcit-swiper__dots');

    // Build dots
    dotsWrap.innerHTML = '';
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.addEventListener('click', () => goTo(i, true));
      dotsWrap.appendChild(dot);
    });

    let positions = [];
    let index = 0;
    let t;

    const computePositions = () => { positions = slides.map(s => s.offsetLeft); };
    const updateDots = () => {
      [...dotsWrap.children].forEach((d, i) => d.setAttribute('aria-selected', i === index ? 'true' : 'false'));
    };
    const updateButtons = () => {
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= slides.length - 1;
    };
    const goTo = (i, smooth) => {
      index = clamp(i, 0, slides.length - 1);
      updateDots(); updateButtons();
      track.scrollTo({ left: positions[index], behavior: smooth ? 'smooth' : 'auto' });
    };
    const nearest = () => {
      const x = track.scrollLeft;
      let best = 0, dist = Infinity;
      for (let i = 0; i < positions.length; i++) {
        const d = Math.abs(positions[i] - x);
        if (d < dist) { dist = d; best = i; }
      }
      return best;
    };

    // Wire
    prevBtn?.addEventListener('click', () => goTo(index - 1, true));
    nextBtn?.addEventListener('click', () => goTo(index + 1, true));
    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') goTo(index - 1, true);
      if (e.key === 'ArrowRight') goTo(index + 1, true);
    });
    track.addEventListener('scroll', () => {
      clearTimeout(t);
      t = setTimeout(() => { index = nearest(); goTo(index, true); }, 80);
    }, { passive: true });

    const ro = new ResizeObserver(() => {
      requestAnimationFrame(() => { computePositions(); goTo(index, false); });
    });
    ro.observe(track);
    slides.forEach(s => ro.observe(s));

    // A11y labels
    const heading = root.closest('.custom-mcit')?.querySelector('.custom-mcit__title');
    root.setAttribute('aria-roledescription', 'carousel');
    root.setAttribute('aria-label', heading?.textContent?.trim() || 'Carousel');
    dotsWrap.setAttribute('aria-label', 'Slide pagination');

    // Init
    computePositions();
    goTo(0, false);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const mq = window.matchMedia('(max-width: 989px)');
    const setup = () => {
      document.querySelectorAll('.mcit-swiper[data-mobile-swiper="true"]').forEach((el) => {
        if (el.__hp8Swiper) return;
        if (!mq.matches) return;     // mobile only
        el.__hp8Swiper = true;
        init(el);
      });
    };
    setup();
    mq.addEventListener('change', setup);
  });
})();
